import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import MarkdownLink from './MarkdownLink';

interface MarkdownProps {
  children: string;
  className?: string;
}

const MarkdownContainer = styled.div`
  line-height: 1.5;
  ul {
    padding-left: 1.5em;
    margin: 0;
    margin-top: 0;
  }

  li {
    margin-bottom: 0.3em;
    line-height: inherit;
  }

  a {
    cursor: pointer;
  }

  .markdown-download-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
`;

const Markdown = ({ children, className }: MarkdownProps) => {
  return (
    <MarkdownContainer>
      <ReactMarkdown
        remarkPlugins={[remarkBreaks]}
        components={{
          p: ({ node, ...props }) => <p className={className} {...props} />,
          a: MarkdownLink,
        }}
      >
        {children}
      </ReactMarkdown>
    </MarkdownContainer>
  );
};

export default Markdown;